const roles = {
    admin: "admin",
    user: "user",
    guest: "guest",
  };
  
  const permissions = {
    VIEW_DASHBOARD: "VIEW_DASHBOARD",
    EDIT_USERS: "EDIT_USER",
  };
  
  const rolePermissions = {
    admin: [permissions.VIEW_DASHBOARD, permissions.EDIT_USERS],
    user: [permissions.VIEW_DASHBOARD],
    guest: []
  };
  
  export { roles, permissions, rolePermissions };
